import { useEffect, useState } from 'react';

interface UseScrollDetectionProps {
  bannerRef: React.RefObject<HTMLDivElement>;
}

export const useScrollDetection = ({ bannerRef }: UseScrollDetectionProps) => {
  const [isScrolledPast, setIsScrolledPast] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const bannerHeight = bannerRef.current?.offsetHeight || 0;
      setIsScrolledPast(scrollPosition > (bannerHeight - 10));
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial scroll position

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    isScrolledPast,
  };
}; 